import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { DialogConfirmAction } from '../../../components/dialogs/DialogConfirmAction';
import { useDispatch } from 'react-redux';
import { useDataAuth } from '../../../hooks/useDataAuth';

export const LoadActions = ({ data, handleEdit, handleDelete, t }) => {
    const [{ userSession }] = useDataAuth();
    const dispatch = useDispatch();
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [idUser, setIdUser] = useState(false);
    const DeleteUser = () => {
        setOpenConfirmation(false);
        dispatch(handleDelete(userSession.token, idUser));
    }

    return (
        <>
            <Box>
                <Tooltip title={t('edit')}>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleEdit(data, false)}
                        sx={{
                            color: 'gray',
                        }}
                    >
                        <Edit />
                    </IconButton>
                </Tooltip>

                <Tooltip title={t('delete')}>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            setOpenConfirmation(true);
                            setIdUser(data.id_user);
                        }}
                        sx={{
                            color: 'red',
                        }}
                    >
                        <Delete />
                    </IconButton>
                </Tooltip>
            </Box>

            <DialogConfirmAction
                openDialogConfirm={openConfirmation}
                setOpenDialogConfirm={() => setOpenConfirmation(false)}
                titleDialog={'Eliminar usuario'}
                textConfirmAction={"¿Esta seguro que desea eliminar el registro?"}
                textButtonConfirm={"Aceptar"}
                textButtonCancel={"Cancelar"}
                handleConfirmAction={DeleteUser}
            />
        </>
    )
}